import { t } from "@lingui/core/macro";
import { DialogPanel } from "@medoma/components/DialogPanel/DialogPanel";
import { Decline } from "./Decline";
import {
  getPatientFullName,
  type IRegisteredPatient,
} from "@medoma/models/patients";

export const DeclineDialog = ({
  isOpen,
  onClose,
  onDeclined,
  patient,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDeclined: () => void;
  patient: IRegisteredPatient;
}) => {
  const patientName = getPatientFullName(patient.name);

  return (
    <DialogPanel
      isOpen={isOpen}
      onClose={onClose}
      title={t`Avslå ${patientName}`}
    >
      <Decline patient={patient} onDeclined={onDeclined} />
    </DialogPanel>
  );
};
